import clsx from 'clsx'
import * as React from 'react'
import { makeStyles } from 'tss-react/mui'
import { classToFComponent, FCClassContext, ToolbarDivider, ToolbarSectionTitle } from 'src/utils/views'

import Stack from '@mui/material/Stack'

import { HeaderScope } from '../gm_scopes'

const useStyles = makeStyles()(() => ({
    view: {
        display: 'flex',
        alignSelf: 'stretch',
        gap: 5,
        marginLeft: 5,
        minWidth: 0
    },
    title: {
        justifyContent: 'center',
        minWidth: 0
    }
}))

type HeaderProps = {
    className?: string
    scope: HeaderScope
}

class HeaderViewClass implements FCClassContext<HeaderProps> {
    // :: Fields

    scope!: HeaderScope

    // :: Emissors

    // <EMPTY>

    // :: Methods

    onSyncState({ scope }: HeaderProps) {
        this.scope = scope
    }

    render(props: HeaderProps): React.JSX.Element {
        const classes = useStyles().classes

        return (
            <div className={clsx(classes.view, props.className)}>
                <ToolbarDivider orientation="vertical" variant="middle" flexItem />
                <Stack className={classes.title}>
                    <ToolbarSectionTitle>Administração :: Grupos</ToolbarSectionTitle>
                </Stack>
            </div>
        )
    }
}
export const HeaderView = classToFComponent(HeaderViewClass, React)
export default HeaderView
